/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MailArrowInIcon20Light = forwardRef('MailArrowInIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M5 4a3 3 0 0 0-3 3v2.5a.5.5 0 0 0 1 0V7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2.5a.5.5 0 0 0 0 1H15a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H5Z" }),
        React.createElement("path", { d: "M5.312 6.81a.5.5 0 1 0-.624.78l3.375 2.701a3.1 3.1 0 0 0 3.874 0l3.375-2.7a.5.5 0 1 0-.624-.781l-3.376 2.7a2.1 2.1 0 0 1-2.624 0l-3.376-2.7Z" }),
        React.createElement("path", { d: "M.5 11a.5.5 0 0 1 .5.5v.5a3 3 0 0 0 3 3h4l-2.8-2.1a.5.5 0 0 1 .6-.8l2.933 2.2c.8.6.8 1.8 0 2.4L5.8 18.9a.5.5 0 0 1-.6-.8L8 16H4a4 4 0 0 1-4-4v-.5a.5.5 0 0 1 .5-.5Z" })));
});
